export default __webpack_public_path__ + "static/media/user-fill.e9b233d6.svg";